import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const OfficesWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default OfficesWrapper;